const typeFamilyBase = 'Calibre, Arial, sans-serif';
const displayFamilyBase = 'Lyon, Georgia, Serif';

export const KlpFonts = {
    fontFamily: typeFamilyBase,
    htmlFontSize: 16,
    fontSize: 16,
    h1: {
        fontFamily: displayFamilyBase,
        fontSize: '1.875rem',
        lineHeight: '2.4375rem',
        fontWeight: 700,
    },
    h2: {
        fontFamily: displayFamilyBase,
        fontSize: '1.5rem',
        lineHeight: '1.8125rem',
        fontWeight: 700,
    },
    h3: {
        fontSize: '1.625rem',
        lineHeight: '2.25rem',
        fontWeight: 400,
    },
    h4: {
        fontSize: '1.5rem',
        lineHeight: '2.0625rem',
        fontWeight: 300,
    },
    h5: {
        fontSize: '1.3125rem',
        lineHeight: '1.875rem',
        fontWeight: 300,
    },
    h6: {
        fontSize: '1.1875rem',
        lineHeight: '1.6875rem',
        fontWeight: 300,
    },
};
